module.exports = __webpack_public_path__ + "static/media/Transferd.c41861d5.svg";